import { CartContent, CartItem } from '@/client/services/vendor/models';

export type fulfillmentGroupsType = {
    fulfillmentProfileId: string;
    fulfillmentAddressId: string;
    fulfillmentType: string;
    fulfillmentDate: string | null;
    fulfillmentFee: number;
    items: CartItem[];
};

export interface GroupedCartContent extends Omit<CartContent, 'items'> {
    items: {
        provider: string;
        storeName: string;
        storeRating: number;
        storeAddress: string;
        storeReviewCount: number;
        fulfillmentGroups: fulfillmentGroupsType[];
    }[];
}

export function groupCartContent(cart: CartContent): GroupedCartContent {
    const providerMap = new Map<string, Map<string, CartItem[]>>();

    for (const item of cart.items) {
        const { providerId, fulfillmentProfileId } = item;

        if (!providerMap.has(providerId)) {
            providerMap.set(providerId, new Map());
        }

        const fulfillmentMap = providerMap.get(providerId)!;

        if (!fulfillmentMap.has(fulfillmentProfileId)) {
            fulfillmentMap.set(fulfillmentProfileId, []);
        }

        fulfillmentMap.get(fulfillmentProfileId)!.push(item);
    }

    const groupedItems = Array.from(providerMap, ([provider, fulfillmentMap]) => {
        const firstFulfillmentItems = fulfillmentMap.values().next().value as CartItem[] | undefined;
        const firstProviderItem = firstFulfillmentItems![0];

        return {
            provider,
            storeName: firstProviderItem.storeName,
            storeRating: firstProviderItem.storeRating,
            storeAddress: firstProviderItem.storeAddress,
            storeReviewCount: firstProviderItem.storeReviewCount,
            fulfillmentGroups: Array.from(fulfillmentMap, ([fulfillmentProfileId, items]) => {
                const firstItem = items[0];

                return {
                    fulfillmentProfileId,
                    fulfillmentAddressId: firstItem.fulfillmentAddressId,
                    fulfillmentType: firstItem.fulfillmentType,
                    fulfillmentDate: firstItem.fulfillmentDate,
                    fulfillmentFee: firstItem.fulfillmentFee,
                    items
                };
            })
        };
    });

    return {
        ...cart,
        items: groupedItems
    };
}
